import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 md:py-20 bg-[#FFF8ED] px-4" data-id="element-255">
      <div className="max-w-3xl mx-auto" data-id="element-256">
        <FadeInSection data-id="element-257">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border-4 border-amber-100 text-center relative overflow-hidden" data-id="element-258">
            <div className="absolute top-0 left-0 w-full h-2 bg-green-600" data-id="element-259"></div>

            <Shield className="w-20 h-20 text-green-600 mx-auto mb-6" data-id="element-260" />

            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-261">
              Mi Garantía de Hierro de 30 Días
            </h2>

            <div className="space-y-4 text-lg md:text-xl text-gray-800 leading-relaxed text-left" data-id="element-262">
              <p data-id="element-263">
                Estoy tan seguro de que "El Código del Azúcar en Sangre"
                cambiará tu relación con la comida, que asumo todo el riesgo.
              </p>
              <p data-id="element-264">
                Descarga el eBook hoy. Lee la estrategia. Aplica la Secuencia de
                Oro en tu próxima comida.
              </p>
              <p data-id="element-265">
                Si en los próximos 30 días no sientes más energía, si tus
                antojos no disminuyen drásticamente, o si simplemente sientes
                que esto no es para ti...
              </p>
              <p className="font-bold text-green-700 text-center text-2xl py-4" data-id="element-266">
                Te devolveré cada centavo de tu inversión. Sin preguntas. Sin
                complicaciones.
              </p>
              <p data-id="element-267">
                Solo envías un correo y procesamos tu reembolso. Tienes todo por
                ganar y absolutamente nada que perder.
              </p>
            </div>
          </div>
        </FadeInSection>
      </div>
    </section>;
}